// prettier-ignore
import { Paper, Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Typography, IconButton, TextField, Checkbox, Link, CircularProgress, Backdrop } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import React, { Fragment, useState } from 'react';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import { Label, useLabelStyles } from '../../common/Label';
import { goBack } from '../../../utils/helper';
import { makeStyles } from '@material-ui/core/styles';
import SystemTable from '../SystemTable';
import LRCTable from '../LRCTable';
import settings from '../../../utils/settings';
import { findIndex } from '../../../utils/lodash';
import { termsConditionsLink, feinLink } from '../constant';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    '& input': {
      padding: `${theme.spacing(0.5)}px ${theme.spacing(1.5)}px !important`
    },
    '& input + fieldset': {
      borderRadius: theme.spacing(0),
      padding: `${theme.spacing(0.5)}px !important`,
      height: theme.spacing(3)
    }
  },
  pagination: { display: 'flex', alignItems: 'center', fontSize: 14 },
  button: { marginRight: theme.spacing(3), fontSize: 14, height: theme.spacing(4.5) },
  checkout: { color: theme.palette.primary.white, marginRight: 0, minWidth: theme.spacing(25) },
  footerWrapper: { padding: theme.spacing(3, 2), display: 'flex', fontSize: 14, alignItems: 'center' },
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h6': {
      color: '#335977',
      fontSize: 28,
      fontWeight: 'bold'
    }
  },
  closeButton: {
    padding: 0
  },
  buttonWrapper: {
    display: 'flex',
    marginLeft: 'auto'
  },
  tableWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  },
  checkBox: {
    padding: 0,
    marginRight: theme.spacing(1)
  },
  linkColour: {
    color: theme.palette.tertiary.main,
    cursor: 'pointer'
  },
  bodyText: {
    fontSize: 14
  },
  termsConditions: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3)
  },
  inputField: {
    width: theme.spacing(37.5)
  },
  dialogContent: {
    border: '1px solid #7070704d',
    padding: theme.spacing(2),
    margin: theme.spacing(0, 2.5)
  },
  feinNote: {
    fontSize: 12,
    color: '#9A9A9A',
    padding: theme.spacing(2.5, 0),
    borderBottom: '1px solid #70707033'
  },
  actionWrapper: {
    padding: theme.spacing(2),
    justifyContent: 'flex-start',
    '& button': {
      fontWeight: 'bold'
    }
  },
  cancelButton: {
    color: '#919191'
  },
  important: {
    color: 'red',
    display: 'inline-block',
    float: 'left',
    padding: theme.spacing(2, 0),
    marginTop: theme.spacing(0.25)
  },
  mobileFooter: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  mobileButtonWrapper: {
    flexDirection: 'column',
    margin: 'auto',
    width: '100%'
  },
  mobileButton: {
    marginRight: 0,
    margin: theme.spacing(2, 0)
  },
  mobilePagination: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  mobilePaginationNumber: {
    marginTop: theme.spacing(1)
  },
  backdrop: {
    zIndex: 11,
    color: theme.palette.primary.main
  }
}));

export default function Systems(props) {
  const {
    data,
    selectedColumns,
    LREPlans,
    tier,
    message,
    loading,
    updateState,
    setPurchase,
    purchase,
    purchasedList,
    updateLREItems,
    addItemsToCart,
    companyId,
    updateColumns,
    windowWidth,
    feinNumber: defaultFein = '',
    updateCompanyInfo,
    checkoutEnabled = false,
    sitesDetail,
    isEligibleSite,
    toggleEligibleSite,
    isMobileView,
    fromIFrame,
    lrePlansBySiteId,
    selectedSiteId,
    getDownloadAgreement
  } = props;
  const classes = useStyles();
  const labelClass = useLabelStyles();
  const [ showAlertDialog, toggleAlertDialog ] = useState(false);
  const [ feinNumber, setFeinNumber ] = useState(defaultFein);
  const [ isValueChanged, setIsValueChanged ] = useState(false);
  const [ showCheckout, setShowCheckout ] = useState(false);
  const [ isTermAccepted, toggleTermAccepted ] = useState(false);
  const [ isNextEnabled, setNextEnabled ] = useState(false);
  const [ cartUrl, setCartUrl ] = useState('');
  const firstIndex = (data.page - 1) * data.limit;

  const addToCart = () => {
    if (sitesDetail && sitesDetail.length > 0) {
      const skuDetails = LREPlans.map(lre => {
        return {
          sku: lre.sku,
          discount: lre.discount_percentage || 0,
          site_ids_90d: [],
          site_ids_max: []
        };
      });

      sitesDetail.forEach(item => {
        if (item && item.periods && item.periods.length > 0) {
          const { sku, qty, is90d } = item.periods[0];
          const skuDetailsIndex = findIndex(skuDetails, skuDetail => skuDetail.sku === sku);
          if (skuDetailsIndex >= 0) {
            const siteValues = {
              id: item.site_id,
              qty
            };
            if (is90d) {
              skuDetails[skuDetailsIndex].site_ids_90d.push(siteValues);
            } else {
              skuDetails[skuDetailsIndex].site_ids_max.push(siteValues);
            }
          }
        }
      });
      const skuLength = skuDetails.length;
      for (var i = 0; i < skuLength; i++) {
        const emptySiteIndex = findIndex(skuDetails, skuDetail => {
          return (
            skuDetail &&
            skuDetail.site_ids_90d &&
            skuDetail.site_ids_90d.length <= 0 &&
            skuDetail.site_ids_max &&
            skuDetail.site_ids_max.length <= 0
          );
        });
        if (emptySiteIndex >= 0) {
          skuDetails.splice(emptySiteIndex, 1);
        }
      }

      const filterSkuDetails = skuDetails.map(detail => {
        if (detail && detail.site_ids_90d && detail.site_ids_90d.length <= 0) {
          delete detail.site_ids_90d;
        }
        if (detail && detail.site_ids_max && detail.site_ids_max.length <= 0) {
          delete detail.site_ids_max;
        }
        return detail;
      });

      filterSkuDetails.length > 0 &&
        addItemsToCart({
          skuDetails: filterSkuDetails,
          successCbk: result => {
            setCartUrl(result.cartUrl);
            toggleAlertDialog(true);
          }
        });
    }
  };

  const redirectToStore = () => {
    const href = window.location.href;
    const apiLink = settings.digiCoreUrl(`enp_lre/updatePurchaseInfo`);
    const url = `${cartUrl}&redirect_api=${encodeURIComponent(apiLink)}&redirect_url=${encodeURIComponent(href)}`;
    fromIFrame ? window.open(url, '_parent') : window.open(url, '_self');
  };

  const preventDefault = (event, key) => {
    if (event.which !== 8 && event.which !== 0 && (event.which < 48 || event.which > 57)) {
      event.preventDefault();
    }
  };

  const handleChange = e => {
    setFeinNumber(e.target.value);
    !isValueChanged && setIsValueChanged(true);
    enableNext(e.target.value, isTermAccepted);
  };

  const handleCheckboxChange = e => {
    toggleTermAccepted(e.target.checked);
    const value = isValueChanged ? feinNumber : defaultFein;
    enableNext(value, e.target.checked);
  };

  const enableNext = (feinValue, isTermsAccepted) => {
    const value = (feinValue && feinValue.toString()) || '';
    if (value && (value.length === 9 && isTermsAccepted)) {
      setNextEnabled(true);
    } else {
      setNextEnabled(false);
    }
  };

  const closeDialog = () => {
    toggleAlertDialog(false);
    setShowCheckout(false);
    toggleTermAccepted(false);
    setFeinNumber(defaultFein);
    setIsValueChanged(false);
    setNextEnabled(false);
  };

  const handleNext = () => {
    const value = isValueChanged ? feinNumber : defaultFein;
    updateCompanyInfo({
      body: {
        company_mongo: { fein_number: value, skip_profile_validation: true, skip_lead_program_validations: true }
      },
      companyId,
      cb: () => {
        setShowCheckout(true);
        redirectToStore();
      },
      enableCb: true
    });
  };
  return (
    <Fragment>
      <Paper className={classes.root} elevation={3}>
        <Box className={classes.tableWrapper}>
          <SystemTable
            data={data.sites}
            selectedColumns={selectedColumns}
            message={message}
            loading={loading}
            updateState={updateState}
            updateColumns={updateColumns}
            windowWidth={windowWidth}
            isMobileView={isMobileView}
            selectedSiteId={selectedSiteId}
          />
          <LRCTable
            data={data.sites}
            LREPlans={LREPlans}
            tier={tier}
            message={message}
            loading={loading}
            setPurchase={setPurchase}
            updateLREItems={updateLREItems}
            purchase={purchase}
            purchasedList={purchasedList}
            companyId={companyId}
            windowWidth={windowWidth}
            isEligibleSite={isEligibleSite}
            toggleEligibleSite={toggleEligibleSite}
            isMobileView={isMobileView}
            lrePlansBySiteId={lrePlansBySiteId}
            getDownloadAgreement={getDownloadAgreement}
          />
        </Box>
        <Box className={clsx(classes.footerWrapper, isMobileView && classes.mobileFooter)}>
          <Box className={clsx(classes.pagination, classes.mobilePagination)}>
            Showing {firstIndex + 1} to {firstIndex + data.total_display_records} of {data.total_records} systems &nbsp;
            <Pagination
              className={clsx(classes.mobilePaginationNumber)}
              count={Math.ceil(data.total_records / data.limit)}
              page={data.page}
              variant="outlined"
              shape="rounded"
              onChange={(event, page) => updateState(null, false, page)}
              showFirstButton
              showLastButton
              size="small"
            />
          </Box>
          <Box className={clsx(classes.buttonWrapper, isMobileView && classes.mobileButtonWrapper)}>
            {!fromIFrame && (
              <Button
                onClick={() => goBack()}
                className={clsx(classes.button, isMobileView && classes.mobileButton)}
                color="primary"
                variant="outlined"
              >
                Cancel
              </Button>
            )}
            <Button
              className={clsx(classes.button, classes.checkout)}
              variant="contained"
              color="primary"
              disableElevation
              disabled={!checkoutEnabled}
              onClick={() => addToCart()}
            >
              Proceed to Checkout
            </Button>
          </Box>
        </Box>
      </Paper>
      {showCheckout && fromIFrame ? (
        <Backdrop className={classes.backdrop} open>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Dialog
          open={showAlertDialog}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className={classes.dialogHeader} disableTypography>
            <Typography variant="h6">Confirmation</Typography>
            {!showCheckout && (
              <IconButton aria-label="close" className={classes.closeButton} onClick={() => closeDialog()}>
                <CloseIcon />
              </IconButton>
            )}
          </DialogTitle>
          {showCheckout ? (
            <Fragment>
              <DialogContent>
                <DialogContentText>
                  You are being redirected to store.enphase.com to complete the checkout process.
                </DialogContentText>
              </DialogContent>
            </Fragment>
          ) : (
            <Fragment>
              <DialogContent className={classes.dialogContent}>
                <DialogContentText component="div">
                  <TextField
                    id="name"
                    className={clsx(classes.inputField, labelClass.customLabel)}
                    label={<Label text="Please enter/confirm your FEIN number" isRequired />}
                    InputProps={{ inputProps: { maxLength: 9 } }}
                    value={isValueChanged ? feinNumber : defaultFein}
                    onKeyPress={e => preventDefault(e)}
                    onChange={e => handleChange(e)}
                  />
                </DialogContentText>
                <Typography className={classes.important}>*</Typography>
                <Typography component="div" className={classes.feinNote}>
                  {`FEIN (Federal Tax Identification Number or an Employer Identification Number), is a unique nine-digit
                number issued to entities that do business in the United States. This is assigned by the IRS to identify
                your business. `}
                  <Link href="#" onClick={() => window.open(feinLink, '_blank')} className={classes.linkColour}>
                    {`Click here to know more`}
                  </Link>
                </Typography>
                <Box className={classes.termsConditions}>
                  <Checkbox
                    checked={isTermAccepted}
                    onChange={e => handleCheckboxChange(e)}
                    color="primary"
                    value="primary"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                    className={classes.checkBox}
                  />
                  <Typography component="div" className={classes.bodyText}>
                    {`I accept the `}
                    <Link
                      href="#"
                      onClick={() => window.open(termsConditionsLink, '_blank')}
                      className={classes.linkColour}
                    >
                      {`Terms & Conditions`}
                    </Link>
                    {` of the Labor Protection Program`}
                  </Typography>
                </Box>
              </DialogContent>
              <DialogActions className={classes.actionWrapper}>
                <Button onClick={() => closeDialog()} autoFocus className={classes.cancelButton}>
                  Cancel
                </Button>
                <Button
                  onClick={() => handleNext()}
                  color="primary"
                  variant="contained"
                  disableElevation
                  disabled={!isNextEnabled}
                  className={clsx(classes.button, classes.checkout)}
                >
                  Proceed
                </Button>
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      )}
    </Fragment>
  );
}
